<template>
  <section id="MapPricing">
    <div id="MapAnchor" />
    <b-container>
      <div class="sNp-cnt">
        <div class="my-content my-seats">
          <div class="content section-title">
            <div class="title-box seating-map">
              <div class="title">Seating <span>Map</span></div>
            </div>
          </div>
          <div class="content">
            <div class="block seat-area">
                <div class="seating-cnt">
                  <div class="seatingBox" 
                      v-for="(info, index) in global.allUserAccs"
                      :key="'seating' + index"
                    >
                    <div class="row expiring item">
                      <span>Section</span>
                      <span>Row</span>
                      <span>Seat(s)</span>
                    </div>
                    <div class="row expiring pricing" :class="'row' + index">
                      <span>{{ info.sectionLevel }}</span>
                      <span>{{ info.rowLevel }}</span>
                      <span>{{ info.firstSeat }}-{{ info.lastSeat }}</span>
                    </div>
                  </div>
                  <div class="white-divider"></div>
                </div>
                <div class="seating-map-cnt">
                  <img src="@/assets/seating-map.png"/>
                  <div class="interactive-map-btn-cnt">
                    <a class="btn interactive-map" href="https://denverbroncos.io-media.com/web/index.html" target="_blank">3D Interactive Map</a>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "MapPricing",
    computed: {
      ...mapState(["global"]),
    },
    data() {
      return {
        zone: "red",
        section: 336,
        row: 12,
        seats: "1-2",
        current: 4350,
        twoYear: 3850
      }
    }
  }
</script>

<style lang="scss" scoped>
  @mixin flexCenter { justify-content:center; align-items:center; }

  $cw: 1000px;
  $cwHalf: 500px;
  $mw: 880px;

#MapPricing {
  position: relative;
  background: url('~@/assets/bg/bg-seating-and-pricing.png') scroll no-repeat top right, linear-gradient(0deg, #FFF 0%, #F8F8F8 100%);
  background-size: auto 100%;
  min-height: 800px;
  padding: 85px 0 50px;
  #MapAnchor {
    position: absolute;
    top: 0;
    left: 0;
  }
  .title-box {
    width: 100%;
    &.dark-bg {
      .title {
          color: $orange;
        span {
          color: $white;
        }
      }
      .underline {
          background: #021734;
        &.full {
          max-width: 100%;
        }
      }
    }
    &.orange-bg {
      .title {
        color: $white;
        span {
        color: $blue;
        }
      }
      .underline {
        background: #C43A00;
      }
    }
    &.payment-plans {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    &.seating-map {
      margin-bottom: 80px;
    }
    &.account-profile {
      margin-bottom: 50px;
    }
    .title {
      z-index: 2;
      position: relative;
      text-align: left;
      font-size: 22px;
      @include nofex;
      line-height: 31px;
      text-transform: uppercase;
      color: $orange;
      span {
        position: relative;
        display: block;
        font-size: 58px;
        @include nexaBold;
        line-height: 1;
        color: $dark-blue;
      }
    }
    .plan-info {
      max-width: 560px;
      margin: 20px 0 10px;
      p {
        font-size: 14px;
        @include nexaBold;
        line-height: 18px;
        text-align: left;
        color: $white;
        a {
          text-decoration: underline;
          color: $white;
        }
      }
    }
    .underline {
      width: 100%;
      max-width: 470px;
      margin-top: 20px;
      height: 6px;
    }
  }
  .container {
    width: 1040px;
  }
  div.my-content.my-seats {
    div.content { 
      display: flex; 
      flex-direction: column;
      &.section-title {
        .title-box {align-self:flex-start;}
      }
      div.block {
        display: block;
        width: 100%;
        position: relative;
        &.seat-area {
          margin-bottom: 15px;
          .seating-cnt {
            .seatingBox {
              margin-bottom: 15px;
            }
          }
        }
        div.row {
          display: inline-flex;
          position: relative;
          width: 100%;
          height: auto;
          margin: 0;
          &.expiring {
            span {
              &:first-of-type {
                width: 33.3333%;
              }
              &:nth-child(2) {
                width: 33.3333%;
              }
              &:nth-child(3) {
                width: 33.3333%;
              }
            }
          }
          span {
            position: relative;
            display: inline-flex;
            width: 15%;
            font-size: 28px;
            @include nofex;
            line-height: 38px;
            text-transform: uppercase;
            color: $dark-blue;
            &:first-of-type {
              width: 60%;
            }
            &:nth-child(2) {
              width: 20%;
            }
            &:nth-child(3) {
              width: 10%;
            }
            &:nth-child(4) {
              width: 10%;
              text-align: right;
              justify-content: flex-end;
            }
          }
          &.item {
            text-transform: uppercase;
            span {
              font-size: 15px;
              @include nexaBold;
              line-height: 18px;
              color: $orange;
            }
          }
          @media (max-width: $mw) {
            span {
              font-size: 15px;
              line-height: 16px;
              width: 60px;
              &:first-child {
                width: calc(100% - 180px);
              }
            }
            &.item {
              span {
                font-size: 12px;
                padding-bottom: 5px;
              }
            }
          }
        }
        .seating-map-cnt {
          position: relative;
          display: flex;
          width: 100%;
          justify-content: center;
          margin-top: 30px;
          img {
            width: 100%;
            max-width: 490px;
          }
          .interactive-map-btn-cnt {
            position: absolute;
            top: 0;
            right: 0;
            a.btn {
              position: relative;
              display: inline-flex;
              @include flexCenter;
              padding: 10px 5px;
              font-size: 13px;
              @include nexaBold;
              line-height: 18px;
              text-align: center;
              text-transform: uppercase;
              text-decoration: none;
              &.interactive-map {
                width: 178px;
                height: 33px;
                background: url('~@/assets/bg/interactive-map-bg.png') scroll no-repeat center center;
                background-size: 178px 33px;
                color: $white;
              }
            }
          }
        }
      }
      div.white-divider {
        position: relative;
        display: block;
        width: 100%;
        height: 6px;
        background-color: #EDEDED;
      }
    }
  }
}
</style>